import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-days-count',
    imports: [NgClass],
    templateUrl: './days-count.component.html',
    styleUrl: './days-count.component.scss'
})
export class DaysCountComponent {
  @Input() dayCount: number;
  @Input() showText = true;
  @Input() size: 'default' | 'big' = 'default';
  @Input() classes: string = '';
  protected readonly Math = Math;
}
